import ApiService from './ApiService';

const AuthService = {
  me: () => ApiService.get('/auth/me'),
  googleClientId: () => ApiService.get('/auth/google/client-id'),
  facebookAppId: () => ApiService.get('/auth/facebook/app-id'),
  signInWithGoogle: (credential) => ApiService.post('/auth/google', { credential }),
  signInWithGoogleAccessToken: (accessToken) => ApiService.post('/auth/google', { access_token: accessToken }),
  signInWithFacebook: (accessToken) => ApiService.post('/auth/facebook', { access_token: accessToken }),
  signin: (username, password) => ApiService.post('/auth/signin', { username, password }),
  signinOtp: (loginId, verificationId, verificationCode) => ApiService.post('/auth/signin/otp', {
    login_id: loginId, verification_id: verificationId, verification_code: verificationCode,
  }),
  loginVerification: (loginId) => ApiService.post('/auth/login-verification', { login_id: loginId }),
  signupVerification: (mobile) => ApiService.post('/auth/userverification', { login_mobile: mobile }),
  signup: (body) => ApiService.post('/auth/signup', body),
  requestPasswordReset: (loginId) => ApiService.post('/auth/password-reset/request', { login_id: loginId }),
  resetPassword: (body) => ApiService.post('/auth/reset-password', body),
  signout: () => ApiService.post('/auth/signout'),
};

export default AuthService;
